import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

export const useActivities = () => {
  const client = useGyymClient()
  return useGyymSWR(client.user.activities.list)
}
